// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Z0H4I","form":"styles_form__12wR9"};